/** The emailed "set your password for the new sign-in" page (ZEY-3140): a menu-less shell route. */
export const CHANGE_PASSWORD_PATH = 'change-password';

/** True for /change-password, with or without a query string, fragment or trailing slash. */
export function isChangePasswordUrl(url: string | null | undefined): boolean {
  const path = (url ?? '').split(/[?#]/)[0].replace(/\/+$/, '');
  return path === `/${CHANGE_PASSWORD_PATH}`;
}
